import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'studio-components';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { ProjectSummary } from 'src/app/store/project/models/project-summary.model';

@Component({
  selector: 'app-project-deploy-dialog',
  standalone: true,
  imports: [CommonModule, DialogModule],
  templateUrl: './project-deploy-dialog.component.html',
  styleUrls: ['./project-deploy-dialog.component.scss'],
})
export class ProjectDeployDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ProjectDeployDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ProjectSummary,
  ) {}

  public confirm() {
    this.dialogRef.close(true);
  }

  public cancel() {
    this.dialogRef.close(false);
  }
}
